import httpClient from "@/config/httpClient";
import { endpoints } from "@/utils/common/requests/endpoints";

export async function fetchMyCrews() {
	const { isError, response } = await httpClient.get(endpoints.crew.GET_CURRENT());

	if (isError) return null;
	return response.crews;
}
